import titleManage from "@/api/operateManage/titleManage";

export default {
  data() {
    return {
      titleParams: {},
      titleForm: {
        title: "",
        subTitle: ""
      },
      titleEditonfig: {
        title: false,
        subTitle: false
      }
    };
  },
  created() {
    this.initTitleInfo();
  },
  methods: {
    async initTitleInfo() {
      const res = await titleManage.getTitleInfo(this.titleParams);
      if (!res.Success) {
        return;
      }
      this.titleForm.title = res.Data.title || "";
      this.titleForm.subTitle = res.Data.subtitle || "";
    },
    async handleSwitchEditTitle(name, config) {
      const titleNameConfig = config || {
        title: "主标题",
        subTitle: "副标题"
      };
      if (this.titleEditonfig.title || this.titleEditonfig.subTitle) {
        const res1 = await titleManage.addOrUpdateTitle({
          ...this.titleParams,
          title: this.titleForm.title,
          subtitle: this.titleForm.subTitle
        });
        this.$message({
          message: `${titleNameConfig[name]}保存${res1.Data.result ? '成功': '失败'}！`,
          type: res1.Data.result ? "success" : "error"
        });
      }
      this.titleEditonfig[name] = !this.titleEditonfig[name];
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/title.js